import { createSlice } from "@reduxjs/toolkit";

const fullDrawerSlice = createSlice({
    name: "fullDrawer",
    initialState: {
        visible: false,
        content: null,
    },
    reducers: {
        openFullDrawer: (state, action) => {
            state.visible = true;
            state.content = action.payload;
        },
        closeFullDrawer: (state) => {
            state.visible = false;
            state.content = null;
        },
    },
});

export const { openFullDrawer, closeFullDrawer } = fullDrawerSlice.actions;
export default fullDrawerSlice.reducer;
